enum MapName {
  MAX_LOCATION_LIMIT = "brick_area_locations",
}

export default MapName;
